import { FC } from 'react';
import { Tank } from 'src/types/ViewModel/Vessel/Tank';
import TankContainer from './TankContainer';
import styled from 'styled-components';
import { TankPlanCondition } from 'src/enums/stowage/tankPlanCondition';

interface TankWrapperProps {
    tank: Tank;
    x: number;
    y: number;
    width: number;
    height: number;
    onZoomClick?: (tank: Tank, event: React.MouseEvent) => void;
    tankPlanCondition: TankPlanCondition;
    isReport?: boolean;
    filterTanksForReport?: boolean;
}

const TankPosition = styled.div<{ x: number; y: number; width: number; height: number }>`
    position: absolute;
    left: ${(props) => props.x}%;
    top: ${(props) => props.y}%;
    width: ${(props) => props.width}%;
    height: ${(props) => props.height}%;
`;

const TankWrapper: FC<TankWrapperProps> = ({ tank, x, y, width, height, onZoomClick, tankPlanCondition, isReport, filterTanksForReport = false }) => {
    return (
        <TankPosition x={x} y={y} width={width} height={height}>
            <TankContainer
                tank={tank}
                onZoomClick={(e) => {
                    if (onZoomClick) {
                        onZoomClick(tank, e);
                    }
                }}
                tankPlanCondition={tankPlanCondition}
                isReport={isReport}
                filterTanksForReport={filterTanksForReport}
            />
        </TankPosition>
    );
};

export default TankWrapper;
